import { useDictee } from "@/components/assistant/useDictee";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mic, Send } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, messageErreur } from "@/lib/api";
import { formatDateHeure } from "@/lib/format";

export function DiscussionFiche({ fiche }) {
  const { user } = useAuth();
  const [liste, setListe] = useState([]);
  const [texte, setTexte] = useState("");
  const charger = useCallback(() => api.get(`/fiches/${fiche.id}/discussion`).then((r) => setListe(r.data)).catch(() => {}), [fiche.id]);
  useEffect(() => { charger(); }, [charger]);
  const dictee = useDictee((t) => setTexte((x) => [x.trim(), t].filter(Boolean).join(" ")));
  if (!fiche.partenaire_id || user.role === "agent") return null;
  const envoyer = () => texte.trim() && api.post(`/fiches/${fiche.id}/discussion`, { texte }).then(() => { setTexte(""); charger(); }).catch((e) => toast.error(messageErreur(e)));
  return (
    <section className="at-card p-4 space-y-3 min-w-0" data-testid="fiche-discussion">
      <p className="font-bold">Échanges confirmateur ↔ partenaire</p>
      <div className="space-y-2 max-h-80 overflow-y-auto" data-testid="discussion-list">
        {liste.length === 0 && <p className="text-sm at-muted">Aucun message pour l'instant.</p>}
        {liste.map((m) => {
          const moi = m.auteur_id === user.id;
          return (
            <div key={m.id} className={`max-w-[85%] p-3 ${moi ? "ml-auto" : ""}`} style={{ borderRadius: 16, background: moi ? "var(--accent)" : "var(--surface-2)", color: moi ? "var(--accent-ink)" : "var(--ink)" }} data-testid={`discussion-msg-${m.id}`}>
              <p className="text-xs font-semibold opacity-80">{m.auteur_nom} · {formatDateHeure(m.created_at)}</p>
              <p className="text-sm whitespace-pre-line break-words">{m.texte}</p>
            </div>
          );
        })}
      </div>
      <textarea value={texte} onChange={(e) => setTexte(e.target.value)} rows={2} maxLength={2000} placeholder="Votre message ou commentaire…" className="at-input !h-auto py-2" data-testid="discussion-input" />
      <div className="grid grid-cols-[auto_1fr] gap-2">
        <button type="button" onClick={() => (dictee.actif ? dictee.arreter() : dictee.demarrer() || toast.error("Dictée indisponible sur ce navigateur : écrivez votre message."))} className="at-btn !min-h-[56px] !min-w-[56px] !px-0 at-pill" style={{ background: "var(--micro)", color: "var(--micro-ink)" }} aria-label="Dicter (lot 4)" data-testid="discussion-mic"><Mic size={22} /></button>
        <button type="button" disabled={!texte.trim()} onClick={envoyer} className="at-btn at-btn-primary !min-h-[56px]" data-testid="discussion-send"><Send size={16} />Envoyer</button>
      </div>
    </section>
  );
}
